import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';

export default withStyles({
  select: {
    fontSize: '0.9rem',
  },
})(Select);
